import { useState } from 'react';

/**
 * @param {*} location
 * @param {Object} history
 */
export const useDrawer = (location, history) => {
  const [uiState, setUiState] = useState({
    isDrawerOpen: false
  });

  const toggleDrawer =
    (drawer, open, additionalUi = {}) =>
    event => {
      if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
      setUiState(prevState => ({ ...prevState, [drawer]: open, ...additionalUi }));
      !open && history.replace(location.pathname);
    };

  return { toggleDrawer, uiState };
};

export default useDrawer;
